export default __webpack_public_path__ + "static/banner-shop-for-christmas-on-a-budget-914f94786f71a3cb21ac2de3e716bdaa.jpg";